/*
 * @Author: changcheng
 * @LastEditTime: 2024-02-20 10:29:31
 */
import { Empty, message } from "antd";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import "./_style.scss";
import { RootState, store } from "@root/store";
import { querSaveUserWatchTime } from "@root/common/service";
interface CourseListProps {
  id: number;
  courseDurationText: string;
  imageAllPath: string;
  playCount: number;
  clickCount: number;
  name: string;
}
export default function CourseList(props: { data: CourseListProps[] }) {
  const { data = [] } = props;
  const { access_token, userDetailInfo } = useSelector(
    (item: RootState) => item.userInfo
  );
  const navigate = useNavigate();
  /**
   * 调用接口保存状态
   */
  const saveHomePageSaveEnterInerface = (
    sourceId: number,
    sourceName: string
  ) => {
    var startTime = new Date().valueOf() / 1000;
    let data = [
      {
        sourceType: 3,
        sourceId,
        sourceName,
      },
    ];
    const {
      userInfo: { uumsId = "" },
    } = store.getState();
    const leaveTime = Math.floor(new Date().valueOf() / 1000 - startTime);
    data.length && querSaveUserWatchTime(data, leaveTime, uumsId, 2);
  };
  return (
    <>
      <div className="course_container">
        {data.map((item: CourseListProps, idx: number) => (
          <div
            className="cover_info"
            key={idx}
            onClick={() => {
              if (access_token) {
                if (userDetailInfo && userDetailInfo.status !== "0") {
                  message.info("审核通过后才能观看视频");
                  return;
                }
                const { name, id } = item;
                saveHomePageSaveEnterInerface(id, name);
                navigate(`/play?courseId=${item.id}`);
              } else {
                message.info("请登录后学习课程");
              }
            }}
          >
            <div className="cover_content">
              <img src={item.imageAllPath} alt="" />
              <h4 className="course_name">{item.name}</h4>
              <div className="video_info">
                <p>播放次数：{item.playCount + item.clickCount}次</p>
                <p>视频时长：{item.courseDurationText}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      {data.length === 0 && <Empty />}
    </>
  );
}
CourseList.defaultProps = {
  data: [],
};
